import React from 'react';
import {
    useOrderSaleAccountIdInputQuery,
    useOrderSaleOrderSaleReceiptTypeInputQuery,
} from '../../../../../../../../services';
import { RhSingleAutocomplete } from '../../../../../../../dum';
import {
    CREDIT_NOTE_AMOUNT,
    IOrderSale,
    REQUIRE_CREDIT_NOTE,
    REQUIRE_INVOICE_CODE,
    REQUIRE_SUPPLEMENT,
} from '../../order-sale-form';
import { useFormContext } from 'react-hook-form';
import { useSetOrderSaleTaxRequirement } from '../../use-set-order-sale-tax-requirement';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../helpers';

export function OrderSaleReceiptTypeInput() {
    const inputName: keyof IOrderSale = 'receipt_type_id';
    const { data } = useOrderSaleOrderSaleReceiptTypeInputQuery();
    const { data: accountsData } = useOrderSaleAccountIdInputQuery();
    const { getValues, setValue } = useFormContext<IOrderSale>();
    const { setOrderSaleTaxRequirement } =
        useSetOrderSaleTaxRequirement();

    const orderSaleReceiptTypes = data?.getReceiptTypes || [];

    return (
        <RhSingleAutocomplete
            itemText={'name'}
            itemValue={'id'}
            name={inputName}
            label={shortLabel(FIELD_LABELS.receipt_type_id)}
            options={orderSaleReceiptTypes}
            onChange={(receiptTypeId) => {
                const receiptType = orderSaleReceiptTypes.find(
                    (type) => type.id === receiptTypeId,
                );
                const appliesTax = receiptType?.applies_tax ?? false;
                const formAccount = getValues('account');
                // Reopened sales carry only a reduced account shape. Resolve
                // the full client defaults from the picker query before
                // deriving the taxable-document settings.
                const account =
                    accountsData?.getAccounts.find(
                        (candidate) => candidate.id === formAccount?.id,
                    ) ?? formAccount;
                setValue(
                    REQUIRE_INVOICE_CODE,
                    appliesTax && !!account?.client_requires_invoice_code,
                    {
                        shouldDirty: true,
                        shouldValidate: true,
                    },
                );
                setOrderSaleTaxRequirement(
                    appliesTax && !!account?.client_requires_tax,
                    {
                        accountAllowsAutomaticTaxCalculation:
                            !!account?.client_automatic_tax_calculation,
                    },
                );
                setValue(
                    REQUIRE_SUPPLEMENT,
                    appliesTax && !!account?.client_require_supplement,
                    {
                        shouldDirty: true,
                        shouldValidate: true,
                    },
                );
                setValue(
                    REQUIRE_CREDIT_NOTE,
                    appliesTax && !!account?.client_require_credit_note,
                    {
                        shouldDirty: true,
                        shouldValidate: true,
                    },
                );
                // A non-taxable receipt cannot carry a complemento or a nota de
                // crédito, so clear the amount when the user switches to one.
                // The requirements above are recomputed in both directions from
                // the selected client's defaults.
                if (!appliesTax) {
                    setValue(CREDIT_NOTE_AMOUNT, 0, {
                        shouldDirty: true,
                        shouldValidate: true,
                    });
                }
            }}
        />
    );
}
